/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  query AccountReadTwoFactorAuthQuery($accountId: ID!) {
    AccountReadTwoFactorAuth(accountId: $accountId) {
      qrCode,
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
